import Story from "@/components/sections/Story";
import GuestBook from "@/components/sections/GuestBook";

export default function StoryPage() {
  return (
    <div className="pt-16">
      <Story />
      <GuestBook />
    </div>
  );
}
